import VueBaseController from '../../vue_base'

export class IndexController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/clients/ai_content/content_types/index.vue') }
}

export class NewController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/clients/ai_content/content_types/new.vue') }
}

export class EditController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/clients/ai_content/content_types/edit.vue') }

  static values = {
    contentType: Object
  }

  connect() {
    super.connect(this.contentTypeValue)
  }
}

export class ShowController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/clients/ai_content/content_types/show.vue') }

  static values = {
    contentType: Object
  }

  connect() {
    super.connect(this.contentTypeValue)
  }
}
